import CustomerEngagementView from 'views/CustomerEngagement'

const CustomerEngagement = () => <CustomerEngagementView />

export default CustomerEngagement
